const isLive = window.location.protocol === 'https:'
export const USER_BASE_URL = isLive ? 'https://api.draivatar.com/User/api' : 'http://192.168.0.53:6002/User/api'
export const IMAGE_URL = isLive ? 'https://api.draivatar.com/' : 'http://192.168.0.53:6002/'
export const STRIPE_PUBLISHABLE_KEY = 'pk_test_51TYfkYRrkPk0cSN5Dnjl6ohl57Dk0hTKHXWEnMWJ4JGSiaLoPmncRMY8sX8ecC0f3hjnTQLHQSAznn3pcFkzYIFG00ra0fLVOz'

// // ==========END-POINTS============
export const SignUp = '/sign-up'
export const LOGIN = '/login'
export const LOGOUT = '/logout'
export const OTP = '/check-otp'
export const PROFILE = '/view-profile'
export const GETPASTHISTORY = '/get-past-history'
export const CHANGEPASSWORD = '/change-password'
export const FORGOT_PASSWORD = '/forgot-password'
export const RESET_PASSWORD = '/set-new-password'
export const EDIT = '/edit'
export const RESENDOTP = '/send-otp'
export const EDITBASICINFO = '/edit-basic-info'
export const EDITMEDICALINFO = '/edit-medical-info'
export const CHECKSECURITYCODE = '/check-security-code'
export const CONSULTATION = '/add-consultation'
export const CONSULTATIONDATA = '/get-complete-consultation'
export const ADD_NEW_CONSULTATION = '/add-new-consultation'
export const OPENCONSULTATION = '/get-open-consultation'
export const GETCHATDATA = '/chat'
export const FETCHCHAT = '/chat'
export const GENERTAEVIDEO = "/generate-video"
export const GETVIDEO = "/video-status"
export const SEND_PDF_TO_EMAIL = "/download-pdf"
export const SEND_CONDITION = "/update-condition"
export const GET_ALL_CONSULTATION = "/get-all-consultations"
export const GET_DOCTOR_LIST = '/get-doctors-list';
export const MEDICAL_HISTORY = '/medical-history';
export const DOCTOR_EMAIL_ADDRESS = '/doctor-email-address'
export const ADDITIONAL_MEDICAL_REPORT = '/additional-medical-report'
export const CREATE_SETUP_INTENT = '/create-setup-intent'
export const GET_SAVED_CARDS = '/get-saved-cards'
export const CHARGE_CONSULTATION = '/charge-consultation'
export const SET_DEFAULT_CARD = '/set-default-card'
export const GET_CMS = '/cms'

//FT33n6pG6KzoXM69 webteamdeftsoft_db_user